export default function KeyFeatures() {
  return (
    <section className="bg-[#F5F2EB] py-32 px-6">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start mb-20">
          <div>
            <h2 className="text-4xl font-bold text-gray-600 mb-1">LO QUE</h2>
            <h3 className="text-5xl italic text-black font-serif">Aprenderás</h3>
          </div>
          <div className="md:w-[65%] mt-6 md:mt-0">
            <p className="text-base text-gray-700 leading-relaxed">
              Este curso te proporciona las herramientas teóricas y prácticas para entender el entrenamiento 
              desde sus fundamentos científicos. No aprenderás rutinas copiadas, sino los principios que te 
              permitirán crear, adaptar y optimizar cualquier programa de entrenamiento.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="flex flex-col">
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/fbce855509b2febe6af6892150b714bc.jpg"
                alt="Biomecánica"
                className="w-full h-64 object-cover rounded-3xl"
              />
              <div className="inline-block bg-[#C8E6C9] px-5 py-2 rounded-full -mt-4 ml-6 relative z-10">
                <span className="text-sm font-medium text-[#1A3A2E]">BIOMECÁNICA</span>
              </div>
            </div>
            <h4 className="text-2xl font-bold text-black mt-6 leading-tight">
              Anatomía Funcional y Mecánica del Movimiento
            </h4>
          </div>

          <div className="bg-black rounded-3xl p-12 flex flex-col justify-between">
            <div className="w-16 h-16 bg-[#3A3A3A] rounded-full flex items-center justify-center">
              <span className="text-white text-3xl font-bold">M</span>
            </div>
            <div className="mt-8">
              <h4 className="text-3xl font-bold text-white leading-tight mb-4">
                Metodologías Comparadas
              </h4>
              <p className="text-base text-gray-400">
                Weider, HIT, Heavy Duty, Periodización
              </p>
            </div>
          </div>

          <div className="flex flex-col">
            <h4 className="text-3xl font-normal text-black leading-tight mb-3 font-serif">
              Nutrición Deportiva Aplicada
            </h4>
            <p className="text-[15px] text-gray-600 mb-6">
              Timing, macros y suplementación real
            </p>
            <img
              src="https://readdy.ai/api/search-image?query=healthy%20protein%20rich%20foods%20composition%20with%20supplements%20clean%20organized%20layout%20chicken%20eggs%20protein%20powder%20simple%20white%20background%20professional%20food%20photography&width=600&height=400&seq=feature002&orientation=landscape"
              alt="Nutrición"
              className="w-full h-56 object-cover rounded-2xl mt-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
